const CARD_WIDTH = 1200;
const CARD_HEIGHT = 630;

const roundedRect = (ctx, x, y, width, height, radius) => {
  ctx.beginPath();
  ctx.roundRect(x, y, width, height, radius);
  ctx.fill();
};

const fitText = (ctx, text, maxWidth, startSize, minSize = 28) => {
  let size = startSize;
  do {
    ctx.font = `700 ${size}px system-ui, -apple-system, sans-serif`;
    if (ctx.measureText(text).width <= maxWidth) break;
    size -= 2;
  } while (size > minSize);
  return size;
};

export const createResultCardBlob = (result) => new Promise((resolve, reject) => {
  const canvas = document.createElement('canvas');
  canvas.width = CARD_WIDTH;
  canvas.height = CARD_HEIGHT;
  const ctx = canvas.getContext('2d');
  if (!ctx) {
    reject(new Error('Score card rendering is not supported by this browser.'));
    return;
  }

  const background = ctx.createLinearGradient(0, 0, CARD_WIDTH, CARD_HEIGHT);
  background.addColorStop(0, '#1d4ed8');
  background.addColorStop(1, '#7e22ce');
  ctx.fillStyle = background;
  ctx.fillRect(0, 0, CARD_WIDTH, CARD_HEIGHT);

  ctx.fillStyle = 'rgba(255, 255, 255, 0.13)';
  ctx.beginPath();
  ctx.arc(1040, 80, 220, 0, Math.PI * 2);
  ctx.fill();
  ctx.beginPath();
  ctx.arc(90, 600, 260, 0, Math.PI * 2);
  ctx.fill();

  ctx.fillStyle = 'rgba(255, 255, 255, 0.96)';
  roundedRect(ctx, 70, 65, 1060, 500, 36);

  ctx.fillStyle = '#2563eb';
  ctx.font = '800 34px system-ui, -apple-system, sans-serif';
  ctx.fillText('BOOKQUIZ', 120, 132);

  ctx.fillStyle = '#111827';
  const title = result.quizTitle || 'Book Quiz';
  fitText(ctx, title, 650, 52);
  ctx.fillText(title, 120, 220);

  ctx.fillStyle = '#6b7280';
  ctx.font = '500 30px system-ui, -apple-system, sans-serif';
  ctx.fillText(result.bookTitle || 'Test your book knowledge', 120, 270);

  ctx.fillStyle = '#f3f4f6';
  roundedRect(ctx, 120, 325, 600, 145, 24);
  ctx.fillStyle = '#111827';
  ctx.font = '700 38px system-ui, -apple-system, sans-serif';
  ctx.fillText(`${result.correct} / ${result.total} correct`, 165, 390);
  ctx.fillStyle = '#6b7280';
  ctx.font = '500 27px system-ui, -apple-system, sans-serif';
  ctx.fillText('Can you beat my score?', 165, 437);

  const scoreGradient = ctx.createLinearGradient(780, 170, 1030, 450);
  scoreGradient.addColorStop(0, '#2563eb');
  scoreGradient.addColorStop(1, '#7e22ce');
  ctx.fillStyle = scoreGradient;
  ctx.beginPath();
  ctx.arc(900, 325, 145, 0, Math.PI * 2);
  ctx.fill();
  ctx.fillStyle = '#ffffff';
  ctx.textAlign = 'center';
  ctx.font = '800 82px system-ui, -apple-system, sans-serif';
  ctx.fillText(`${result.score}%`, 900, 345);
  ctx.font = '600 24px system-ui, -apple-system, sans-serif';
  ctx.fillText('MY SCORE', 900, 390);

  ctx.textAlign = 'left';
  ctx.fillStyle = '#6b7280';
  ctx.font = '500 22px system-ui, -apple-system, sans-serif';
  ctx.fillText('bookquiz.jeet.world', 120, 525);

  canvas.toBlob((blob) => {
    if (blob) resolve(blob);
    else reject(new Error('Could not create the score card.'));
  }, 'image/png');
});

export const downloadResultCard = async (result) => {
  const blob = await createResultCardBlob(result);
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `bookquiz-${result.score}-percent.png`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};

export const shareResult = async (result, challengeUrl) => {
  if (!navigator.share) return false;
  const text = `I scored ${result.score}% on ${result.quizTitle}. Can you beat me?`;
  const shareData = { title: `${result.quizTitle} challenge`, text, url: challengeUrl };

  try {
    const blob = await createResultCardBlob(result);
    const file = new File([blob], 'bookquiz-score.png', { type: 'image/png' });
    if (navigator.canShare?.({ files: [file] })) shareData.files = [file];
  } catch (_) {
    // Text and link sharing still work if canvas or file sharing is unavailable.
  }

  await navigator.share(shareData);
  return true;
};

export const copyChallengeLink = async (url) => {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(url);
    return;
  }
  const input = document.createElement('textarea');
  input.value = url;
  input.setAttribute('readonly', '');
  input.style.position = 'fixed';
  input.style.opacity = '0';
  document.body.appendChild(input);
  input.select();
  document.execCommand('copy');
  input.remove();
};
